import React from "react";
import "./Description.css";
const Description = ({ children }: { children: React.ReactNode }) => {
  return <p className="description">{children}</p>;
};

export default Description;
